import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { SecondaryButton } from '@/styles/blocks';
import { DetailList } from './blocks';

/**
 * Read-only dialog with everything the board knows about one item, service, or claim card, opened from the card's info
 * button. Closing it (Close, Escape, or a click outside) returns focus to that button.
 *
 * @param {{ details: { title: string, rows: Array<{ label: string, value: string }> }|null, onClose: () => void }} props
 *   `details` is open while set; build its rows with `itemDetailRows`, `serviceDetailRows`, or `claimDetailRows`.
 */
export const CardDetailsDialog = ({ details, onClose }) => (
    <Dialog open={!!details} onClose={onClose} maxWidth="sm" fullWidth aria-labelledby="split-card-details-title">
        <DialogTitle id="split-card-details-title">{details?.title}</DialogTitle>
        <DialogContent>
            <DetailList data-testid="split-card-details">
                {(details?.rows || []).map(({ label, value }) => (
                    <React.Fragment key={label}>
                        <dt>{label}</dt>
                        <dd>{value}</dd>
                    </React.Fragment>
                ))}
            </DetailList>
        </DialogContent>
        <DialogActions>
            <SecondaryButton onClick={onClose}>Close</SecondaryButton>
        </DialogActions>
    </Dialog>
);

export default CardDetailsDialog;
